import Swal from "sweetalert2";

/* ====================================================
   ⏳ Loading
==================================================== */
export function loadingDialog() {
  Swal.fire({
    title: "Loading...",
    didOpen: () => {
      Swal.showLoading();
    },
    showConfirmButton: false,
    allowOutsideClick: false,
  });
}

/* ====================================================
   🗑 Generic Delete Confirmation
==================================================== */
export function deleteDialog() {
  return Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,

    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "Cancel",

    buttonsStyling: false,
    reverseButtons: true,

    customClass: {
      popup: "card",
      confirmButton: "btn-danger",
      cancelButton: "btn-secondary",
    },
  });
}

/* ====================================================
   ✅ Success Toast
==================================================== */
export function successDialog(message: string) {
  return Swal.fire({
    toast: true,
    position: "top",
    icon: "success",
    title: message,
    timer: 2000,
    showConfirmButton: false,
    timerProgressBar: true,
    willOpen: () => {
      const container = document.querySelector(
        ".swal2-container"
      ) as HTMLElement;
      if (container) {
        container.style.zIndex = "1000";
      }
    },
  });
}

/* ====================================================
   💾 Save Changes Dialog
==================================================== */
export function saveChangeDialog() {
  return Swal.fire({
    title: "Save changes?",
    icon: "question",
    showDenyButton: true,
    showCancelButton: false,

    confirmButtonText: "Save",
    denyButtonText: "Don't save",

    buttonsStyling: false,
    customClass: {
      popup: "card",
      confirmButton: "btn-primary",
      denyButton: "btn-secondary",
    },
  });
}

/* ====================================================
   ❌ Error Dialog (Simple)
==================================================== */
export function errorDialog(message: string): void {
  Swal.fire({
    icon: "error",
    title: "Error",
    html: `
      <div style="font-size:15px; color:#444; margin-top:6px;">
        ${message || "Something went wrong!"}
      </div>
    `,
    buttonsStyling: false,
    confirmButtonText: "OK",
    customClass: {
      popup: "card",
      confirmButton: "btn-danger",
    },
  });
}

/* ====================================================
   🔁 Activate / Deactivate Project
==================================================== */
export function toggleStatusDialog(isActivating: boolean) {
  return Swal.fire({
    title: isActivating ? "Activate Project?" : "Deactivate Project?",
    text: isActivating
      ? "The project will become active and operational."
      : "The project will be disabled and hidden from use.",
    icon: "warning",
    showCancelButton: true,

    confirmButtonText: isActivating ? "Activate" : "Deactivate",
    cancelButtonText: "Cancel",

    buttonsStyling: false,
    reverseButtons: true,

    customClass: {
      popup: "card",
      confirmButton: isActivating ? "btn-primary" : "btn-danger",
      cancelButton: "btn-secondary",
    },
  });
}

/* ====================================================
   🗑 Delete Project (Special wording)
==================================================== */
export function deleteProjectDialog() {
  return Swal.fire({
    title: "Delete Project?",
    html: `
      <div style="font-size:15px; margin-top:8px; color:#555;">
        This action cannot be undone.<br>
        Are you sure you want to permanently delete this project?
      </div>
    `,
    icon: "warning",
    showCancelButton: true,

    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",

    buttonsStyling: false,

    customClass: {
      popup: "card",
      confirmButton: "btn-danger",
      cancelButton: "btn-secondary",
    },
  });
}

/* ====================================================
   ❗ Show Error (HTML)
==================================================== */
export function showError(message: string) {
  return Swal.fire({
    icon: "error",
    title: "Error",
    html: `
      <div style="font-size:15px; color:#444; margin-top:6px;">
        ${message}
      </div>
    `,
    buttonsStyling: false,
    confirmButtonText: "OK",
    customClass: {
      popup: "card",
      confirmButton: "btn-danger",
    },
  });
}



export function confirmMicroserviceToggle(
  serviceName: string,
  enable: boolean
) {
  return Swal.fire({
    title: enable ? "Enable Microservice?" : "Disable Microservice?",
    html: `
      <div style="font-size:15px; color:#444; margin-top:6px;">
        Are you sure you want to
        <b>${enable ? "enable" : "disable"}</b>
        the microservice
        <b>"${serviceName.toUpperCase()}"</b>
        for this project?
      </div>
    `,
    icon: "warning",
    showCancelButton: true,

    confirmButtonText: enable ? "Yes, Enable" : "Yes, Disable",
    cancelButtonText: "No",

    buttonsStyling: false,
    customClass: {
      popup: "card",                // reuse your card style
      confirmButton: enable
        ? "btn-primary"
        : "btn-danger",
      cancelButton: "btn-secondary",
    },
  });
}


/* ====================================================
   🔄 Change User Role Confirmation
==================================================== */
export function confirmRoleChangeDialog(
  oldRoleName?: string,
  newRoleName?: string
) {
  return Swal.fire({
    title: "Change User Role?",
    html: `
      <div style="font-size:15px; color:#444; margin-top:6px;">
        You are about to change the user's role
        ${oldRoleName ? `<br><b>From:</b> ${oldRoleName}` : ""}
        ${newRoleName ? `<br><b>To:</b> ${newRoleName}` : ""}
        <br><br>
        This action may affect user permissions.
        <br><br>
        Are you sure you want to continue?
      </div>
    `,
    icon: "warning",
    showCancelButton: true,

    confirmButtonText: "Yes, change role",
    cancelButtonText: "No",

    buttonsStyling: false,
    reverseButtons: true,

    customClass: {
      popup: "card",
      confirmButton: "btn-primary",
      cancelButton: "btn-secondary",
    },
  });
}
